import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import React from 'react';
import PropTypes from 'prop-types';
import { cx } from 'emotion';
import * as colors from '../colors';
var ascDirection = 'asc';
var descDirection = 'desc';

var Triangle = function Triangle(_ref) {
  var up = _ref.up,
      active = _ref.active,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
  return React.createElement("div", {
    style: _objectSpread({
      width: '0px',
      height: '0px',
      borderLeft: '5px solid transparent',
      borderRight: '5px solid transparent',
      borderBottom: up ? "5px solid ".concat(active ? colors.alloy : colors.shale) : 'none',
      borderTop: up ? 'none' : "5px solid ".concat(active ? colors.alloy : colors.shale)
    }, style)
  });
};

Triangle.propTypes = {
  up: PropTypes.bool,
  active: PropTypes.bool,
  style: PropTypes.shape({})
};

var TableHeader = function TableHeader(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      sortable = _ref2.sortable,
      sorted = _ref2.sorted,
      toggleSort = _ref2.toggleSort,
      rest = _objectWithoutProperties(_ref2, ["children", "className", "sortable", "sorted", "toggleSort"]);

  var direction = sorted && (sorted.desc ? 'desc' : 'asc');
  var sortIcons = React.createElement("div", null, React.createElement(Triangle, {
    active: direction === ascDirection,
    up: true
  }), React.createElement(Triangle, {
    active: direction === descDirection,
    style: {
      marginTop: '2px'
    }
  }));
  return React.createElement("div", _extends({
    className: cx('rt-th', className),
    role: "columnheader",
    tabIndex: "-1"
  }, rest, {
    onClick: function onClick(e) {
      return toggleSort && toggleSort(e);
    }
  }), children, sortable ? sortIcons : null);
};

TableHeader.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  sortable: PropTypes.bool,
  toggleSort: PropTypes.func,
  sorted: PropTypes.shape({
    desc: PropTypes.any
  })
};
export default TableHeader;